import { ClientPendingTaskAdapter } from '~/services/adapters/client-pending-task.adapter';

export class ClientPendingTaskService extends ClientPendingTaskAdapter {}
